import { Box, styledWithConfig } from "../../components/layout";
import { useDom } from "../../context/Dom";

import type { LocationShape } from "../../types";

type Args = {
  to: string | LocationShape;
  disabled?: boolean;
  newTab?: boolean;
  navLink?: boolean;
  replace?: boolean;
  styleProps?: any;
};

const AnchorComponent = styledWithConfig("a");

export function useGetLinkComponentAndProps({
  to,
  disabled,
  newTab,
  navLink,
  replace,
  styleProps
}: Args) {
  const { Link, NavLink } = useDom();

  if (disabled) return { Component: Box };

  const external = isLinkExternal(to);

  if (external)
    return {
      Component: AnchorComponent,
      linkProps: {
        href: to,
        rel: "nofollow noopener noreferrer",
        target: newTab === false ? null : "_blank"
      }
    };

  if (navLink)
    return {
      Component: NavLink,
      linkProps: {
        to,
        target: newTab ? "_blank" : null,
        activeStyle: styleProps.activeNavLinkStyles
      }
    };

  return {
    Component: Link,
    linkProps: {
      replace,
      to,
      target: newTab ? "_blank" : null
    }
  };
}

export function isLinkExternal(link: string | LocationShape) {
  return (
    typeof link === "string" &&
    (link.startsWith("http") || link.startsWith("mailto:"))
  );
}
